<template>
  <div class="container">
    <h1 class="page-title">Offset Your Current Switch</h1>
    <h5>We just need you Switch ID</h5>
    <div class="row _margin-top-40">
      <div class="col-sm-4 col-md-4">
         <div class="card">
           <form name="form">
             <label for="customerId">Your Switch Id</label>

             <div class="row">
               <div class="col-md-12">
                 <validation-messages label="Switch Id" :$v="$v.form.customerId">
                   <form-field id="customerId"
                       v-model="form.customerId"
                       :error="$v.form.customerId.$error"
                   />
                 </validation-messages>
               </div>
             </div>

             <uiv-btn
                 class="_margin-top-20"
                 type="primary"
                 size="lg"
                 block
                 :disabled="requesting"
                 @click="onSubmit">
                 <loader :show="requesting" />See Projects
             </uiv-btn>

             <uiv-alert class="_margin-top-30" type="danger" v-if="error">
               We could not find a switch with this Id
             </uiv-alert>
           </form>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  required, maxLength, minLength, numeric
} from 'vuelidate/lib/validators';

export default {
  name: 'CarbonOffsetExisting',
  data() {
    return {
      error: false,
      requesting: false,
      form: {
        customerId: null
      }
    }
  },
  validations () {
    return {
      form: {
          customerId: {
            required,
            numeric,
            minLength: minLength(1),
            maxLength: maxLength(10)
          }
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('token/getToken');

    this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Carbon Offset Existing' });
    this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Viewed' });
    await this.$store.dispatch('tracing/saveActions');
  },
  methods: {
    async onSubmit() {
      this.error = false;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.requesting = true;
      const found = await this.$store.dispatch('carbon_offset/getCarbonEquivalent', this.form.customerId);
      this.requesting = false;

      if(!found) {
        this.error = true;
      } else {
        this.$router.push({ name: 'carbonOffset', params: { customerId: found }});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 40px;
}
</style>
